import React from 'react';
import {connect} from 'react-redux';
import SelectableListItem from './SelectableListItem';
import {translate} from 'react-i18next';
import {levelFetchData} from './LevelAction';
import List from 'material-ui/List';
import MyButton from '../components/MyButton';
import {navigationBack} from '../navigation/NavigationActions';
import Header from '../components/Header';
import './LevelScreen.css';

class LevelScreen extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			selectedId: props.user.level ? props.user.level : 1,
		};

		this.levels = [
			{
				id: 1,
				title: props.t('level:level1'),
				description: props.t('level:level1_description'),
			},
			{
				id: 5,
				title: props.t('level:level2'),
				description: props.t('level:level2_description'),
			},
			{
				id: 9,
				title: props.t('level:level3'),
				description: props.t('level:level3_description'),
			},
			{
				id: 13,
				title: props.t('level:level4'),
				description: props.t('level:level4_description'),
			},
			{
				id: 17,
				title: props.t('level:level5'),
				description: props.t('level:level5_description'),
			},
		];
	}

	_isSelected(id) {
		const userLevel = this.state.selectedId;

		let selectableLevel = 1;
		if (userLevel >= 1 && userLevel < 5) {
			selectableLevel = 1;
		} else if (userLevel >= 5 && userLevel < 9) {
			selectableLevel = 5;
		} else if (userLevel >= 9 && userLevel < 13) {
			selectableLevel = 9;
		} else if (userLevel >= 13 && userLevel < 17) {
			selectableLevel = 13;
		} else if (userLevel >= 17 && userLevel <= 20) {
			selectableLevel = 17;
		}

		console.log(userLevel + '===' + id);
		return selectableLevel === id;
	}

	_onPressItem = (id) => {
		if (this.props.isLoading) return;
		// updater functions are preferred for transactional updates
		this.setState(() => {
			return {
				selectedId: id,
			};
		});
	};

	render() {
		return (
			<div className='mainBg levelScreenWrapper noSelectAtAll'>
				<Header
					onBackPress={() => this.props.goBack()}
					title={this.props.t('level:title')}
				/>
				<div style={styles.containerShadowBox}>
					<List style={{paddingLeft: 15, paddingRight: 15}}>
						{this.levels.map((item, i) => (
							<SelectableListItem
								hasBottomMargin={{}}
								id={item.id}
								key={item.id}
								onPressItem={this._onPressItem}
								selected={this._isSelected(item.id)}
								title={item.title}
								description={item.description}
							/>
						))}
						<MyButton
							wrapperStyles={{textAlign: 'center'}}
							onPressButton={() => this.setLevel()}
							title={this.props.t('common:save')}
							loading={this.props.isLoading}
							size='large'
							style={{backgroundColor: 'white', color: '#029EE9'}}
						/>
					</List>
				</div>
			</div>
		);
	}

	setLevel = () => {
		this.props.fetchLevel(this.state.selectedId);
	};
}

const styles = {
	containerShadowBox: {
		maxWidth: 1200,
		margin: '0 auto',
		alignItems: 'center',
	},
	flex: {
		flex: 1,
	},
};

const mapStateToProps = (state) => {
	return {
		user: state.auth.user,
		loadingLevelFailed: state.loadingLevelFailed,
		isLoading: state.levelLoading,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchLevel: (level) => dispatch(levelFetchData(level)),
		goBack: () => dispatch(navigationBack()),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(translate(['level', 'common'])(LevelScreen));



// WEBPACK FOOTER //
// ./src/level/LevelScreen.js